import React from 'react';
import {Form} from 'MWC';
import tpl from '../../templates/orderAction/result';

export default class extends Form {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };
        this.sendGA();
        return this;
    }

    sendGA() {
        const data = {
            event: 'show'
        };
        if (window.ga) {
            window.ga('send', 'event', {
                eventCategory: 'видимомть_эл_смайлик'
            });
            window.dataLayer.push(data);
        }
    }

    static displayName = 'Cards.Views.OrderResult';
}
